import React from 'react';
import { PATH } from '~/pages/vendors/deals/[id]/deal_estimation_headers/[headerId]/index';
import { useIdQueryHandler } from '~/hooks/useIdQueryHandler';
import { EstimationHistoryNavigation } from '~/components/common/constructions/navigation/EstimationHistoryNavigation';
import { useDealEstimationHeaders } from '~/hooks/vendors/deals/useDealEstimationHeaders';
import { ConstructionVendorNavigation } from '~/components/common/constructions/navigation/ConstructionVendorNavigation';

export const EstimationVendorPanel: React.FC = () => {
  const id = useIdQueryHandler();
  const { data: dealEstimationHeaders } = useDealEstimationHeaders().index(id);
  if (id === null || dealEstimationHeaders === null) {
    return null;
  }
  return (
    <div>
      <ConstructionVendorNavigation title="工事見積書" />
      <EstimationHistoryNavigation
        dealEstimationHeaders={dealEstimationHeaders}
        detailPagePath={(headerId: number): string => PATH(id, headerId)}
      />
    </div>
  );
};
